import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";

export default function ChangePassword() {
  const { user, loading, changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    if (next !== confirm) {
      toast.error("Le due password non corrispondono");
      return;
    }
    if (next.length < 8) {
      toast.error("La nuova password deve avere almeno 8 caratteri");
      return;
    }
    if (next === current) {
      toast.error("Scegli una password diversa da quella attuale");
      return;
    }
    setBusy(true);
    try {
      await changePassword(current, next);
      toast.success("Password aggiornata");
      nav("/", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Errore aggiornamento password";
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "var(--bg-app)" }}
      data-testid="change-password-page"
    >
      <div
        className="w-full max-w-[380px] rounded-xl p-8"
        style={{
          background: "var(--bg-surface)",
          border: "1px solid var(--border-subtle)",
          boxShadow: "var(--shadow-lg)",
        }}
      >
        <div className="flex items-center gap-2.5 mb-6">
          <Logo size={32} />
          <div>
            <div
              className="font-semibold text-[17px]"
              style={{ color: "var(--text-primary)" }}
            >
              Cambia password
            </div>
            <div
              className="text-[12px]"
              style={{ color: "var(--text-muted)" }}
            >
              {user.must_change_password
                ? "Primo accesso — imposta una password personale"
                : "Aggiorna la tua password"}
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-3" data-testid="change-form">
          {["Password attuale", "Nuova password", "Conferma nuova password"].map(
            (label, i) => (
              <div key={label}>
                <label
                  className="block text-[11px] font-medium mb-1 uppercase tracking-wide"
                  style={{ color: "var(--text-secondary)" }}
                >
                  {label}
                </label>
                <input
                  type="password"
                  required
                  value={[current, next, confirm][i]}
                  onChange={(e) =>
                    [setCurrent, setNext, setConfirm][i](e.target.value)
                  }
                  className="w-full h-10 px-3 rounded-md text-[14px] outline-none"
                  style={{
                    border: "1px solid var(--border-default)",
                    background: "var(--bg-surface)",
                    color: "var(--text-primary)",
                  }}
                  data-testid={`change-${i === 0 ? "current" : i === 1 ? "new" : "confirm"}`}
                />
              </div>
            )
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full h-10 rounded-md text-[14px] font-medium mt-2"
            style={{
              background: "var(--accent-primary)",
              color: "var(--text-on-accent)",
            }}
            data-testid="change-submit"
          >
            {busy ? "Aggiornamento…" : "Aggiorna password"}
          </button>
        </form>
      </div>
    </div>
  );
}
